export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const ACCESS_TOKEN_ERROR = "ACCESS_TOKEN_ERROR";
export const ACCESS_TOKEN_SUCCESS = "ACCESS_TOKEN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_FAIL = "LOGOUT_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA";

//PROFILE REDUCER
export const AUTH_USER_LOAD = "AUTH_USER_LOAD";
export const AUTH_USER_LOAD_ERROR = "AUTH_USER_LOAD_ERROR";
export const PROFILE_UPDATE = "PROFILE_UPDATE";
export const PROFILE_UPDATE_ERROR = "PROFILE_UPDATE_ERROR";

//CONTACT
export const CONTACT_SUCCESS = "CONTACT_SUCCESS";
export const GET_CONTACTS = "GET_CONTACTS";

// PRODUCT REDUCER
export const GET_PRODUCT_DETAILS = "GET_PRODUCT_DETAILS";
export const GET_PRODUCT_DETAILS_ERROR = "GET_PRODUCT_DETAILS_ERROR";
export const GET_PRODUCT_LIST = "GET_PRODUCT_LIST";
export const CREATE_PRODUCT = "CREATE_PRODUCT";
export const CREATE_PRODUCT_ERROR = "CREATE_PRODUCT_ERROR";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_PRODUCT_ERROR = "UPDATE_PRODUCT_ERROR";
export const DELETE_PRODUCT = "DELETE_PRODUCT";
export const DELETE_PRODUCT_ERROR = "DELETE_PRODUCT_ERROR";
export const SUBMIT_FORM = "SUBMIT_FORM";
export const SET_FORM = "SET_FORM";
export const CLEAR_FORM = "CLEAR_FORM";
